const About = () => {
  const aboutList = [
    {
      img: "/images/about1.png",
      txt1: "365일 24시간 언제나",
      txt2: "무료 상담가능!",
    },
    {
      img: "/images/about2.png",
      txt1: "보태거나 더하지 않는",
      txt2: "오차없는 견적",
    },
    {
      img: "/images/about3.png",
      txt1: "서울 수도권 전지역",
      txt2: "긴급출동!",
    },
    {
      img: "/images/about4.png",
      txt1: "누수! 해결하지 못하면",
      txt2: "비용 0원!",
    },
  ];
  return (
    <div
      id="about"
      className="relative w-full h-full px-[calc((100%-var(--container))/2)]  mx-auto py-14 lg:py-28 xl:pb-36"
    >
      <div id="title" className="relative w-full h-fit text-center mb-10">
        <div className="relative w-full h-fit flex justify-center items-end flex-wrap sm:flex-nowrap gap-2">
          <div className="relative w-auto h-fit">
            <img
              className="!relative w-auto h-full max-h-7 lg:max-h-9 2xl:max-h-11 object-contain"
              alt="logo"
              src="/images/logo.png"
              width={430}
              height={104}
            />
          </div>
          <h2 className="leading-none gmedium">
            <span className="hidden sm:inline-block">의</span> 약속&nbsp;4가지
          </h2>
        </div>
        <p className="text-lg lg:text-xl xl:text-2xl mt-2 xl:mt-3">
          누수방수야는&nbsp;고객님께&nbsp;아래와&nbsp;같은
          혜택을&nbsp;약속드립니다!
        </p>
      </div>
      <div className="relative w-full h-full grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 lg:gap-5 ">
        {aboutList.map((v, i) => (
          <div key={i} data-aos="fade-up" className="relative w-full h-full">
            <img
              className="!relative w-full h-44 md:h-52 lg:h-80 2xl:h-[430px] 3xl:h-[500px] object-cover hover:-translate-y-5 transition-transform duration-300 rounded-lg"
              alt="img"
              src={v.img}
              width={434}
              height={641}
            />
            <div className="relative w-full h-16 lg:h-20 2xl:h-24 mt-2 lg:mt-4 border-2 border-primary text-center grid items-center rounded-lg">
              <div className="leading-tight">
                <h5 className="font-light">{v.txt1}</h5>
                <h3 className="text-nowrap text-primary gmarket xl:text-3xl mt-1">
                  {v.txt2}
                </h3>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default About;
